<template lang="pug">
  footer.nav-footer
    ul.nav
      li.nav-item(v-for="({title, route}, i) in footerItems" :key="route")
        a.item-link(:href="buildURL(route)" target="_blank") {{title}}
        i.dots(v-if="i !== footerItems.length-1") &#183;
</template>

<script>
import NavBars from '../../mixins/nav-bars'
export default {
  mixins: [ NavBars, ],
  data () {
    return {
      subURL: 'meta',
    }
  },
}
</script>
<style lang="stylus" scoped>
  @import "../../assets/styles/variables.styl"

  .nav-footer
    position relative
    z-index 0
    width 100%
    padding 50px 10px
    display flex
    align-items center
    justify-content center
    background-color $default-color-bold

    .nav
      display flex
      align-items center
      justify-content center

      .nav-item
        display flex
        align-items center
        .dots
          color $white-color
          padding 5px
        .item-link
          color $white-color
          padding 5px
          font-weight 600

  @media (max-width: $tablet)
    .nav-footer
      .nav
        flex-wrap wrap
        justify-content space-between
        .nav-item
          font-size 85%
          width 50%
          .dots
            display none
</style>



// WEBPACK FOOTER //
// src/components/layout-components/TheFooter.vue